export default {
  CREATE: `#graphql
  mutation createInvoice($order: String!, $personType: String!, $documentType: String!, $sendEmail: Boolean) {
    createInvoice(order: $order, personType: $personType, documentType: $documentType, sendEmail: $sendEmail)      
  }`,

  CREATE_CONVEYOR: `#graphql
  mutation createInvoiceConveyor($conveyor: String!, $description: String!, $value: Int!, $order: String, $init: Date, $final: Date!) {
    createInvoiceConveyor(conveyor: $conveyor, description: $description, value: $value, order: $order, init:  $init, final: $final)      
  }`,

  GET_CUSTOMER: `#graphql
  query getInvoiceCustomer($dni: String!) {
    getInvoiceCustomer(dni: $dni)
    {
      order,
      dni,
      name,
      email,
      telephone,
      address,
      location,
      department,
      orderDate
    }
  }`,

  CREATE_INDIVIDUAL: `#graphql
  mutation createInvoiceIndividual($input: InvoiceIndividualInput!) {
    createInvoiceIndividual(input: $input)
    {
      invoice,
      document,
      order,
      value,
      tax,
      process,
      PDF,
      URL
    }
  }`,

  CANCELE: `#graphql
  mutation canceleInvoice($order: String!, $invoice: String!) {
    canceleInvoice(order: $order, invoice: $invoice)         
  }`,

  UPDATE_STATE: `#graphql
  mutation updateStateInvoice($tascode: String!) {
    updateStateInvoice(tascode: $tascode)
    {
      process,
      URL,
      PDF
    }     
  }`,

  RESEND_EMAIL: `#graphql
  mutation resendEmailInvoice($tascode: String!, $email: String!) {
    resendEmailInvoice(tascode: $tascode, email: $email)
  }`,

  SEND_RECEIPT_ACKNOWLEDGEMENT: `#graphql
  mutation sendInvoiceReceiptAcknowledgement($cufe: String!) {
    sendInvoiceReceiptAcknowledgement(cufe: $cufe) {
      success
      alreadyExists
      event
      cufe
      message
    }
  }`,

  GET_ALL: `#graphql
  query getInvoices($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getInvoices(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        invoice,
        type,
        order,
        status,
        value,
        tax,
        process,
        tascode,
        URL,
        PDF,
        createdBy,
        createdAt
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/invoice.js